import { render, staticRenderFns } from "./CrmOptions.vue?vue&type=template&id=3ed29ee5&scoped=true&"
import script from "./CrmOptions.vue?vue&type=script&lang=js&"
export * from "./CrmOptions.vue?vue&type=script&lang=js&"
import style0 from "./CrmOptions.vue?vue&type=style&index=0&id=3ed29ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed29ee5",
  null
  
)

export default component.exports